import React, { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, TextField, Switch, Typography } from '@mui/material';
import { SCUIButton } from '../../../atomic/atoms';
import Swal from 'sweetalert2';
import { GreetingNotesCommand } from '../../../services/command';
import { useTranslation } from 'react-i18next';
import { GREETING, greetingCls } from '../greetingNotes.classes';
interface IProps {
    selectedRow?: any;
    onCloseMenu?: any;
    onUpdate?: any;
}

export const SCUIGreetingNotsDrawerContent: FC<IProps> = ({ selectedRow, onCloseMenu, onUpdate }) => {
    const handleChangeTitle = (event: any) => {
        setTitle(event.target.value);
    };
    const handleChangeText = (event: any) => {
        setText(event.target.value);
    };

    const UpdateGreetingNotes = () => {
        Swal.fire({
            text: 'Güncellemek istediğinizden emin misiniz',
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.update'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                params.id = selectedRow.id;
                params.title = title;
                params.text = text;
                params.status = isChecked;
                GreetingNotesCommand.UpdateGreetingNotes(params);
                Swal.fire(t('general.updated'), ' ', 'success');
                onUpdate();
            }
        });
    };
    const CreateGreetingCard = async () => {
        let params: any = {};
        params.title = title;
        params.text = text;
        params.status = isChecked;
        if (title && title?.trim().length > 0 && text && text?.trim().length > 0) {
            GreetingNotesCommand.PostCreateGreetingNotes(params)
                .then(() => {
                    Swal.fire(t('general.added'), ' ', 'success');
                    onUpdate();
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {});
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };

    const { t } = useTranslation();
    const [title, setTitle] = React.useState(selectedRow.title);
    const [text, setText] = React.useState(selectedRow.text);
    const [isChecked, setIsChecked] = React.useState(selectedRow.isActive);

    const handleChangeSwitch = (event?: any) => {
        setIsChecked(event.target.checked);
    };
    return (
        <Grid className={greetingCls(GREETING.drawerRoot, 'designCollectiveselectedRowGrid')}>
            <Grid className={GREETING.drawerHeaderRow} container sx={{ paddingTop: '2rem' }}>
                <Grid
                    sx={{ paddingLeft: '3rem' }}
                    size={{
                        md: 6,
                        xs: 6,
                        lg: 11,
                    }}
                >
                    <h1 className={greetingCls('headtxt', GREETING.drawerTitle)}>
                        {selectedRow?.title ? 'Hediye Kartını Güncelle' : 'Hediye Kartı Ekleme'}
                    </h1>
                </Grid>

                <Grid
                    size={{
                        md: 1,
                        xs: 1,
                        lg: 1,
                    }}
                >
                    <CloseIcon
                        className={greetingCls('svg_icons', GREETING.inputIconDrawerClose)}
                        onClick={onCloseMenu}
                    />
                </Grid>
            </Grid>
            <Grid className={GREETING.drawerForm} container sx={{ padding: '3rem' }}>
                <br />

                <Grid
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={GREETING.inputTextTitle}
                        label="Başlık"
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={selectedRow?.title}
                        onChange={handleChangeTitle}
                    />
                </Grid>

                <Grid
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={GREETING.inputTextContent}
                        label="İçerik"
                        margin="dense"
                        id="parameterValue"
                        multiline
                        rows={5}
                        fullWidth
                        defaultValue={selectedRow?.text}
                        onChange={handleChangeText}
                    />
                </Grid>
                <Grid
                    className={GREETING.activeSwitchRow}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'flex-end'}
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Typography fontWeight={'bold'} sx={{ mr: 1 }}>
                        Aktiflik Durumu
                    </Typography>
                    <Switch className={GREETING.inputSwitchActive} checked={isChecked} onChange={handleChangeSwitch} />
                </Grid>
                <Grid
                    container
                    sx={{ marginTop: '2rem' }}
                    size={{
                        xs: 6,
                        sm: 6,
                    }}
                ></Grid>
                <Grid
                    className={GREETING.drawerFooterActions}
                    container
                    justifyContent={'flex-end'}
                    sx={{ marginTop: '2rem' }}
                    size={{
                        xs: 6,
                        sm: 6,
                    }}
                >
                    {selectedRow.title ? (
                        <SCUIButton
                            className={GREETING.inputButtonUpdate}
                            text={'Güncelle'}
                            type="primary"
                            sizeType="fixed"
                            size={'l'}
                            onClick={() => UpdateGreetingNotes()}
                        ></SCUIButton>
                    ) : (
                        <SCUIButton
                            className={GREETING.inputButtonSave}
                            text={'Kaydet'}
                            type="primary"
                            sizeType="fixed"
                            size={'l'}
                            onClick={() => CreateGreetingCard()}
                        ></SCUIButton>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};
